import { connect } from 'react-redux';
import SelfAssessmentResults from '../../../../components/AnnualPlanning/SecondTerm/SelfAssessmentResults.tsx';
import {
  currentFulfillmentVersion,
  selectedYear,
  scopeName,
  enterpriseName,
  plans,
  currentPlanId,
  currentBusinessUnit,
  selectedHierarchicalModelId,
  selfAssessmentResults,
  isLoadingSelfAssessmentResults,
} from '@/core/selectors';
import { getPlanValidation } from '@/core/slices/plans';
import { fetchSelfAssessmentResults } from '@/core/slices/selfAssessmentResults';
import { RootState } from '@/core/types/state';

const ConnectedSelfAssessmentResults = connect(
  (state: RootState) => ({
    currentFulfillmentVersion: currentFulfillmentVersion(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    enterpriseName: enterpriseName(state),
    currentPlanId: currentPlanId(state),
    currentPlanName: (() => {
      const planId = currentPlanId(state);
      const plan = plans(state).find((p) => p.APId === planId);
      return plan?.HierarchicalModelName || null;
    })(),
    currentBusinessUnit: currentBusinessUnit(state),
    selectedHierarchicalModelId: selectedHierarchicalModelId(state),
    planValidation: state.plans.planValidation,
    results: selfAssessmentResults(state),
    loadingResults: isLoadingSelfAssessmentResults(state),
  }),
  {
    fetchSelfAssessmentResults,
    getPlanValidation,
  },
)(SelfAssessmentResults);

export default ConnectedSelfAssessmentResults;
